import script from "./login-form.vue?vue&type=script&setup=true&lang=js"
export * from "./login-form.vue?vue&type=script&setup=true&lang=js"

import "./login-form.vue?vue&type=style&index=0&id=29dcf73e&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29dcf73e"]])

export default __exports__